// extracted by mini-css-extract-plugin
export default {"timerWrapper":"Timer_timerWrapper__e5Huq","timer":"Timer_timer__NiuSn"};